import { render, staticRenderFns } from "./PlatformCohorts.vue?vue&type=template&id=1e77673a&scoped=true"
import script from "./PlatformCohorts.vue?vue&type=script&lang=js"
export * from "./PlatformCohorts.vue?vue&type=script&lang=js"
import style0 from "./PlatformCohorts.vue?vue&type=style&index=0&id=1e77673a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e77673a",
  null
  
)

export default component.exports